import React from "react";
import PremiumCheckoutLander from "./PremiumCheckoutLander";

const PremiumYearlyLander: React.FC = () => (
    <PremiumCheckoutLander plan="yearly" />
);

export default PremiumYearlyLander;
